module.exports = [{
      plugin: require('/vercel/493ff508/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-134919186-1"},
    },{
      plugin: require('/vercel/493ff508/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
